import VAppBar from './VAppBar.vue';

export { VAppBar };
export default VAppBar;
